P<template>
  <div
    class="exam-proctoring-modal d-flex flex-column justify-content-start align-items-center"
  >
    <!-- DELETE CAN IMAGE -->
    <img v-lazy="localImg('FaceID.png')" alt="faceID" />

    <!-- TITLE -->
    <div class="title brand_navy text-center text-capitalize">
      Set up Exam Proctoring
    </div>

    <!-- DESCRIPTION -->
    <div class="description color_text text-center">
      Before you start, we need to verify your identity as the person taking
      this examination. Complete the following actions to get started.
    </div>

    <!-- ACTION BUTTONS -->
    <div class="d-flex justify-content-center align-items-center nowrap">
      <button
        class="btn btn-md btn-accent ml-3"
        @click="$emit('startup-proctor')"
      >
        Get Started
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "StartupIntro",
};
</script>

<style lang="scss">
.exam-proctoring-modal {
  margin: 50px 70px;

  img {
    @include equal_min_edge(160);
  }

  .title {
    margin-bottom: 20px;
    margin-top: 24px;
    font-size: 24px;
    line-height: 29px;
    font-weight: 600;
    text-shadow: 0.25px 0 $brand_black;

    @include breakpoint_max(sm) {
      font-size: 16px;
    }

    @include breakpoint_max(xs) {
      font-size: 15px;
    }
  }

  .description {
    font-size: 16px;
    line-height: 165%;
    margin-bottom: 30px;
    width: 105%;

    @include breakpoint_max(sm) {
      font-size: 12px;
      width: 105%;
    }

    @include breakpoint_max(xs) {
      width: 120%;
    }
  }

  .btn {
    @include breakpoint_max(sm) {
      font-size: 11px;
      padding: 10px 22px;
    }
  }
}
</style>